import React, { useState, useEffect } from "react";
import { Col } from "reactstrap";
import { Button, Card } from "../../../../ui";
import { NavList } from "./ui-pending";
import { sideButtons } from "./fileSideBar";
import "./style.scss";
import {
  isTeacherLeaderDisabled,
  isTeacherLeaderTabAllowed,
  TEACHER_LEADER_STUDENT_TABS,
  PROFILE_DATA_UPDATED_EVENT,
} from "../../../../utils/permissions";

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, setActiveTab }) => {
  const [IsOpen, setIsOpen] = useState(false);
  const [tlDisabled, setTlDisabled] = useState(isTeacherLeaderDisabled());

  useEffect(() => {
    const refresh = () => setTlDisabled(isTeacherLeaderDisabled());
    refresh();
    window.addEventListener(PROFILE_DATA_UPDATED_EVENT, refresh);
    return () => window.removeEventListener(PROFILE_DATA_UPDATED_EVENT, refresh);
  }, []);

  const handleTabClick = (tabTitle: string, disabled: boolean) => {
    if (disabled) return;
    setActiveTab(tabTitle);
    if (typeof window !== "undefined" && window.innerWidth < 1200) {
      setIsOpen(false);
    }
  };

  return (
    <Col xs="12" xl="2" className="d-flex flex-column student-profile-tabs-col">
      <div className="md-sidebar d-flex flex-column flex-grow-1 h-100 sp-sidebar">
        <Button
          variant="secondary"
          block
          className="md-sidebar-toggle student-profile-tabs-toggle"
          aria-expanded={IsOpen}
          onClick={() => setIsOpen((open) => !open)}
        >
          {IsOpen ? "Hide sections" : "Sections"} · {activeTab}
        </Button>
        <div className={`md-sidebar-aside job-left-aside flex-grow-1 d-flex flex-column sp-sidebar__aside ${IsOpen ? "open" : ""}`}>
          <Card className="sp-sidebar__card">
            <div className="student-profile-side">
              <NavList
                ariaLabel="Student profile sections"
                activeId={activeTab}
                onSelect={(id) => {
                  const item = sideButtons.find((b) => b.title === id);
                  const disabled =
                    tlDisabled && !isTeacherLeaderTabAllowed(id, TEACHER_LEADER_STUDENT_TABS);
                  if (item) handleTabClick(item.title, disabled);
                }}
                items={sideButtons.map((item) => {
                  const disabled =
                    tlDisabled &&
                    !isTeacherLeaderTabAllowed(item.title, TEACHER_LEADER_STUDENT_TABS);
                  return {
                    id: item.title,
                    label: item.title,
                    disabled,
                    title: disabled ? "Disabled for Teacher Leaders" : undefined,
                  };
                })}
              />
            </div>
          </Card>
        </div>
      </div>
    </Col>
  );
};

export default Sidebar;
